var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5619 3.26666C11.6051 3.18826 11.6685 3.12289 11.7456 3.07736C11.8226 3.03183 11.9104 3.00781 11.9999 3.00781C12.0894 3.00781 12.1773 3.03183 12.2543 3.07736C12.3314 3.12289 12.3948 3.18826 12.4379 3.26666L15.3899 8.87066C15.4603 9.00042 15.5586 9.11299 15.6776 9.20028C15.7967 9.28756 15.9336 9.34741 16.0785 9.37552C16.2235 9.40362 16.3728 9.39929 16.5159 9.36283C16.6589 9.32638 16.7921 9.2587 16.9059 9.16466L21.1829 5.50066C21.265 5.43388 21.3662 5.39487 21.4719 5.38926C21.5776 5.38364 21.6823 5.4117 21.771 5.4694C21.8598 5.5271 21.9279 5.61147 21.9656 5.71035C22.0033 5.80923 22.0087 5.91753 21.9809 6.01966L19.1469 16.2657C19.0891 16.4753 18.9645 16.6604 18.7919 16.7929C18.6194 16.9253 18.4084 16.9979 18.1909 16.9997H5.80994C5.59227 16.9981 5.38105 16.9256 5.20833 16.7932C5.03561 16.6607 4.91083 16.4755 4.85294 16.2657L2.01994 6.02066C1.99219 5.91853 1.99756 5.81023 2.03528 5.71135C2.073 5.61247 2.14112 5.5281 2.22984 5.4704C2.31855 5.4127 2.42329 5.38464 2.52898 5.39026C2.63466 5.39587 2.73583 5.43488 2.81794 5.50166L7.09394 9.16566C7.20773 9.2597 7.34094 9.32738 7.484 9.36383C7.62705 9.40029 7.77641 9.40462 7.92134 9.37652C8.06626 9.34841 8.20317 9.28856 8.32223 9.20127C8.44129 9.11399 8.53954 9.00142 8.60994 8.87166L11.5619 3.26666Z",
    stroke: "#FB4764",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21H19",
    stroke: "#FB4764",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.e926d3e8ebff24e9c3540740b8744499.svg";
export { ForwardRef as ReactComponent };